import ChatBubble from './container'
export { ChatBubble }
export default ChatBubble